"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPortfolioOperation = void 0;
var dataTypes_1 = require("../../dataTypes");
var SolNetworkResolver_1 = require("../../SolNetworkResolver");
/** Gets the portfolio of the given network and address */
exports.getPortfolioOperation = {
    method: 'GET',
    name: 'getPortfolio',
    id: 'getPortfolio',
    groupName: 'account',
    urlPathParamNames: ['network', 'address'],
    urlPathPattern: '/account/{network}/{address}/portfolio',
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request, core) {
    return {
        network: SolNetworkResolver_1.SolNetworkResolver.resolve(request.network, core),
        address: dataTypes_1.SolAddress.create(request.address).address,
    };
}
function deserializeResponse(jsonResponse) {
    return {
        nativeBalance: dataTypes_1.SolNative.create(jsonResponse.nativeBalance.lamports, 'lamports'),
        nfts: jsonResponse.nfts.map(function (nft) {
            return {
                associatedTokenAddress: dataTypes_1.SolAddress.create(nft.associatedTokenAddress),
                mint: dataTypes_1.SolAddress.create(nft.mint),
            };
        }),
        tokens: jsonResponse.tokens.map(function (token) {
            return {
                associatedTokenAddress: dataTypes_1.SolAddress.create(token.associatedTokenAddress),
                mint: dataTypes_1.SolAddress.create(token.mint),
                amount: dataTypes_1.SolNative.create(token.amountRaw, 'lamports'),
            };
        }),
    };
}
function serializeRequest(request, core) {
    return {
        address: dataTypes_1.SolAddress.create(request.address).address,
        network: SolNetworkResolver_1.SolNetworkResolver.resolve(request.network, core),
    };
}
function deserializeRequest(jsonRequest) {
    return {
        network: dataTypes_1.SolNetwork.create(jsonRequest.network),
        address: dataTypes_1.SolAddress.create(jsonRequest.address),
    };
}
//# sourceMappingURL=getPortfolioOperation.js.map